import {handleFillOnScroll, mouseOverImages} from '@/scripts/optional/text-fill-reveal'

window.addEventListener('DOMContentLoaded', () => {
	handleFillOnScroll();
	mouseOverImages();
})